import React from "react";
import { Switch, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";
import VerifyAccountPage from "./VerifyAccountPage";
import NotFoundPage from "./NotFoundPage";
import PrivacyPolicyPage from "./PrivacyPolicyPage";
import OnboardingContactPage from "./OnboardingContactPage";
import HederaVerificationPortal from "./HederaVerificationPortal";
import ReportVerificationById from "./HederaVerificationPortal/ReportVerificationbyID";
import ReportVerificationByPdfUpload from "./HederaVerificationPortal/ReportVerificationByPdfUpload";
import ReportVerification from "./HederaVerificationPortal/ReportVerification";

const PublicApp = () => {
  return (
    <div>
      <div style={{ height: "100vh", overflowY: "auto", overflowX: "hidden" }}>
        <Switch>
          <Route exact path={"/"} component={LoginPage} />
          <Route exact path={"/privacy-policy"} component={PrivacyPolicyPage} />
          <Route exact path={"/recovery"} component={ForgotPasswordPage} />
          <Route
            exact
            path={"/onboarding-contact"}
            component={OnboardingContactPage}
          />
          <Route
            exact
            path={"/resetPassword/:token"}
            component={ResetPasswordPage}
          />
          <Route
            exact
            path={"/verifyAccount/:token"}
            component={VerifyAccountPage}
          />
          {/* <Route
            path={"/result-validator/upload-report/:hash"}
            component={ReportVerification}
          />
          <Route
            path={"/result-validator/upload-report"}
            component={ReportVerificationByPdfUpload}
          />
          <Route
            path={"/result-validator/search/:id"}
            component={ReportVerificationById}
          />
          <Route
            path={"/result-validator/search"}
            component={ReportVerificationById}
          />
          <Route
            path={"/result-validator"}
            component={HederaVerificationPortal}
          /> */}
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </div>
    </div>
  );
};

export default PublicApp;
